import { type RendererElement } from 'vue'

export type MenuAttach = string | RendererElement | null

export const getAttachElm = (attach: MenuAttach = 'body'): RendererElement | null => {
  if (attach === null) {
    return window
  }

  return typeof attach === 'string' ? document.querySelector(attach) : attach
}
